import { Component } from '@angular/core';

@Component({
    selector: 'app-tests',
    standalone: true,
    imports: [],
    templateUrl: './tests.html',
    styleUrl: './tests.css'
})

export class Tests {
	constructor() {}
}